import Vue from 'vue'
import VCalendar from 'v-calendar'
import { vcalendarOptions, Set_Vcalendar_Default_Locale } from '@/utils/vcalendar_options'
import App from './App.vue'
import router from './router'
import store from './store'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { alpha, email, min, required } from 'vee-validate/dist/rules'
import VueTheMask from 'vue-the-mask'
import { validation } from './mixins/validation'
import { general } from './mixins/general'
import './styles/base.less'
import BaseTable from "@/components/BaseTable"
import BaseAutocomplete from "@/components/BaseAutocomplete"
import { Install_Error_Reporter } from '@/error_reporter'
import { resolveMetaAdCookies } from '@/utils'

const META_PIXEL_ID = '846392301875591'

// Persists the ad click/browser ids forwarded by the marketing site's /comenzi
// redirect, on this subdomain, BEFORE the pixel initialises below — so it
// reuses the ids already attributed there instead of minting new ones.
Object.entries(resolveMetaAdCookies(window.location.search)).forEach(([name, value]) => {
  const maxAge = 90 * 24 * 60 * 60 // 90 days, same lifetime Meta's own pixel uses
  document.cookie = `${name}=${value}; domain=app.autoservicepro.ro; path=/; max-age=${maxAge}; SameSite=Lax`
})

// Official Meta Pixel base code (unmodified), translated from the <head> snippet to JS.
;(function (f, b, e, v, n, t, s) {
  if (f.fbq) return
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []
  t = b.createElement(e)
  t.async = true
  t.src = v
  s = b.getElementsByTagName(e)[0]
  s.parentNode.insertBefore(t, s)
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')

window.fbq('init', META_PIXEL_ID)
window.fbq('track', 'PageView')

const moment = require('moment');
require('moment/locale/ro');

Vue.use(require('vue-moment'), {
  moment
});
Vue.use(VueTheMask)
Vue.mixin(validation)
Vue.mixin(general)
Vue.component('BaseTable', BaseTable)
Vue.component('Autocomplete', BaseAutocomplete)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(VCalendar, vcalendarOptions);
Set_Vcalendar_Default_Locale(Vue, store);
extend('required', {
  ...required,
  message: 'This field is required!'
})
extend('email', email)
extend('alpha', alpha)
extend('min', min)
extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target
  },
  message: 'Parolele nu coincid'
})
Vue.config.productionTip = false

Install_Error_Reporter(Vue, router, store)

import Toast, { POSITION } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

Vue.use(Toast, {
  position: POSITION.TOP_RIGHT,
  timeout: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  newestOnTop: true,
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
